import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// import * as ReadSmore from './smore/index.umd'
// window.readSmore = ReadSmore;

// Swiper
import {Swiper, Navigation, Pagination, Thumbs, Autoplay, Grid, EffectCards, FreeMode, Mousewheel} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';
import 'swiper/css/grid';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';

window.Swiper = Swiper

// Lazyload
import lazySizes from 'lazysizes';

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// LightBox
import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.min.css';

var lightbox = new SimpleLightbox('.gallery-lightbox a', {
    rtl: true,
    overlayOpacity: .8,
});
window.lightbox = lightbox;

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// PURE COUNTER
import PureCounter from "@srexi/purecounterjs";
const pure = new PureCounter({
    formater: "fa-Fa",
});


// Model Viewer
import '@google/model-viewer';

const setupApp = ()=>
{
    lazySizes.init();

    lightbox.refresh();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    // NAVBAR BEFORE AND AFTER SCROLL

    const navBar = document.querySelector('.navBar');

    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            navBar.classList.replace('beforScroll', 'afterScroll');
        } else {
            navBar.classList.replace('afterScroll', 'beforScroll');
        }
    });

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Navigation],
        slidesPerView: 1,
        enabled: false,
        // loop: true,
        spaceBetween: 10,
        // autoplay: {
        //     delay: 4500,
        //     disableOnInteraction: false,
        // },
        navigation: {
            nextEl: "#heroSwiperNext",
            prevEl: "#heroSwiperPrev",
        },
    });


    let specialCategoriesSwiper = new Swiper("#specialCategoriesSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1.5,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 4.5,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5.5,
            },
        },
        navigation: {
            nextEl: "#specialCategoriesSwiperNext",
            prevEl: "#specialCategoriesSwiperPrev",
        },
    });

    let specialCategoriesSwiper2 = new Swiper("#specialCategoriesSwiper2", {
        modules: [Grid],
        slidesPerView: 1.3,
        grid: {
            rows: 3,
            fill: 'row'
        },
        loop: false,
        spaceBetween: 14,
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 2.5,
            },
        },
    });

    let specialCategoriesSwiper3 = new Swiper("#specialCategoriesSwiper3", {
        modules: [Navigation],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1.5,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 4.5,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5.5,
            },
        },
        navigation: {
            nextEl: "#specialCategoriesSwiperNext",
            prevEl: "#specialCategoriesSwiperPrev",
        },
    });

    let colorSeparationSwiper = new Swiper("#colorSeparationSwiper", {
        modules: [Grid],
        slidesPerView: 2.5,
        grid: {
            rows: 2,
            fill: 'row'
        },
        spaceBetween: 30,
        breakpoints: {
            480: {
                slidesPerView:2.5,
            },
            768: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 3.5,
            },
            1280: {
                slidesPerView: 5.5,
            },
        },
    });

    let blogSwiper2 = new Swiper("#blogSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: "#blogSwiperNext",
            prevEl: "#blogSwiperPrev",
        },
    });


    // Sliders
    // const heroSwiper = new Swiper('#heroSwiper',  {
    //     modules: [Navigation, Autoplay],
    //     direction: 'horizontal',
    //     slidesPerView: 1,
    //     loop: true,
    //     autoplay: {
    //         delay: 5000,
    //     },
    //     // pagination: {
    //     //     el: ".swiper-pagination",
    //     // },
    //     navigation: {
    //         nextEl: "#heroSwiper-next",
    //         prevEl: "#heroSwiper-prev",
    //     },
    // });

    // const buildSwiperBlog = sliderElm => {
    //     const sliderIdentifier = sliderElm.dataset.id;
    //     return new Swiper('[data-id="'+sliderIdentifier+'"]', {
    //         modules: [Navigation],
    //         direction:'horizontal',
    //         slidesPerView:1.15,
    //         centeredSlides:true,
    //         centeredSlidesBounds:true,
    //         spaceBetween:10,
    //         // navigation:true,
    //         navigation: {
    //             prevEl: '.swiper-button-next-slide-' + sliderIdentifier,
    //             nextEl: '.swiper-button-prev-slide-' + sliderIdentifier,
    //             disabledClass:'!bg-gray-100 text-gray-200'
    //         },
    //         breakpoints: {
    //             // xs
    //             520: {
    //                 slidesPerView:1.6,
    //                 spaceBetween:15,
    //             },
    //             // sm
    //             640:{
    //                 slidesPerView:2,
    //                 spaceBetween:15,
    //             },
    //             // md
    //             768: {
    //                 slidesPerView:2.9,
    //                 spaceBetween:15,
    //
    //
    //             },
    //             // lg
    //             1024:{
    //                 slidesPerView:3.5,
    //                 spaceBetween:15,
    //             },
    //             // xl
    //             1280:{
    //                 slidesPerView: 'auto',
    //                 spaceBetween: 0,
    //                 centeredSlides: false,
    //                 centeredSlidesBounds:true,
    //                 enabled:false,
    //             },
    //             // 2xl
    //             // 1536: {
    //
    //             // },
    //         }
    //     });
    // }
    //
    // const buildSwiperGallery = sliderElm => {
    //     const sliderIdentifier = sliderElm.dataset.id;
    //     return new Swiper('[data-id="'+sliderIdentifier+'"]', {
    //         modules: [Navigation],
    //         direction:'horizontal',
    //         slidesPerView:1.4,
    //         centeredSlides:true,
    //         spaceBetween:15,
    //         centeredSlidesBounds:true,
    //         navigation: {
    //             prevEl: '.swiper-button-next-slide-' + sliderIdentifier,
    //             nextEl: '.swiper-button-prev-slide-' + sliderIdentifier,
    //             disabledClass:'!bg-gray-100 text-gray-200'
    //         },
    //         breakpoints: {
    //             // xs
    //             520: {
    //                 slidesPerView:1.6,
    //                 spaceBetween:15,
    //             },
    //             // sm
    //             640:{
    //                 slidesPerView:2,
    //                 spaceBetween:15,
    //             },
    //             // md
    //             768: {
    //                 slidesPerView:2.9,
    //                 spaceBetween:15,
    //             },
    //             // lg
    //             1024:{
    //                 slidesPerView:3.5,
    //                 spaceBetween:15,
    //             },
    //             // xl
    //             1280:{
    //                 slidesPerView: 'auto',
    //                 spaceBetween: 0,
    //                 centeredSlides: false,
    //                 centeredSlidesBounds:false,
    //                 enabled:false,
    //             },
    //             // 2xl
    //             // 1536: {
    //
    //             // },
    //
    //
    //         }
    //     });
    // }
    //
    //
    // const featuredProductsIndexCardsSwiper = new Swiper('.featured-products-index-swiper-container', {
    //     direction: 'horizontal',
    //     slidesPerView: 1.2,
    //     clickable:"true",
    //     breakpoints:{
    //         768:{
    //             slidesPerView: 1.9,
    //         },
    //         1024: {
    //             slidesPerView: 2.9,
    //             // centeredSlides: true,
    //             // centeredSlidesBounds: true,
    //         },
    //         1248: {
    //             slidesPerView: 4,
    //             slidesOffsetAfter:0,
    //             spaceBetween:20,
    //             loop:false,
    //             clickable:false,
    //             allowSlideNext:false,
    //             allowSlidePrev:false,
    //         }
    //
    //     }
    // });
    //
    // const buildSwiperShop = sliderElm => {
    //     const sliderIdentifier = sliderElm.dataset.id;
    //     return new Swiper('[data-id="'+sliderIdentifier+'"]', {
    //         modules: [Navigation],
    //         direction:'horizontal',
    //         slidesPerView:1.15,
    //         centeredSlides:true,
    //         centeredSlidesBounds:true,
    //         spaceBetween:10,
    //         // navigation:true,
    //         navigation: {
    //             nextEl: '.shop-swiper-button-next-slide-' + sliderIdentifier,
    //             prevEl: '.shop-swiper-button-prev-slide-' + sliderIdentifier,
    //             disabledClass:'!bg-gray-100 text-gray-200'
    //         },
    //         breakpoints: {
    //             // xs
    //             520: {
    //                 slidesPerView:1.6,
    //                 spaceBetween:15,
    //             },
    //             // sm
    //             640:{
    //                 slidesPerView:2,
    //                 spaceBetween:15,
    //             },
    //             // md
    //             768: {
    //                 slidesPerView:2.9,
    //                 spaceBetween:15,
    //
    //
    //             },
    //             // lg
    //             1024:{
    //                 slidesPerView:3.5,
    //                 spaceBetween:15,
    //             },
    //             // xl
    //             1280:{
    //                 slidesPerView: 'auto',
    //                 spaceBetween: 0,
    //                 centeredSlides: false,
    //                 centeredSlidesBounds:true,
    //                 enabled:false,
    //             },
    //             // 2xl
    //             // 1536: {
    //
    //             // },
    //         }
    //     });
    // }
    //
    // const featuredBlogIndexSwiper = new Swiper('.featured-blog-index-swiper-container', {
    //     direction: 'horizontal',
    //     slidesPerView: 1.2,
    //     clickable:"true",
    //     breakpoints:{
    //         768:{
    //             slidesPerView: 1.9,
    //         },
    //         1024: {
    //             slidesPerView: 2.9,
    //             // centeredSlides: true,
    //             // centeredSlidesBounds: true,
    //         },
    //         1248: {
    //             slidesPerView: 4,
    //             slidesOffsetAfter:0,
    //             spaceBetween:20,
    //             loop:false,
    //             clickable:false,
    //             allowSlideNext:false,
    //             allowSlidePrev:false,
    //         }
    //
    //     }
    // });
    //
    // const allSwipersBlog = document.querySelectorAll('.blog-swiper');
    // allSwipersBlog.forEach(slider => buildSwiperBlog(slider));
    //
    // const allSwipersShop = document.querySelectorAll('.shop-swiper');
    // allSwipersShop.forEach(slider => buildSwiperShop(slider));
    //
    // const allSwipersGallery = document.querySelectorAll('.gallery-swiper');
    // allSwipersGallery.forEach(slider => buildSwiperGallery(slider));

    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    const productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

    const videoGalleryThumb = new Swiper('.video-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 5.5,
        centeredSlides:true,
        centeredSlidesBounds:true,
        freeMode: true,
        loop: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            320: {
                slidesPerView: 2.5,
            },
            480: {
                slidesPerView: 2.5,
            },
            640: {
                slidesPerView: 3.5,
            },
            1024: {
                slidesPerView: 4.5,
            }
        }
    });

    const videoGallery = new Swiper('.video-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // clickable:"true",
        spaceBetween: 10,

        thumbs: {
            swiper : videoGalleryThumb
        },
    });

    let aboutHeroSwiper = new Swiper("#contactSwiper", {
        modules: [Navigation, Autoplay],
        slidesPerView: 1,
        spaceBetween: 16,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true,
        centeredSlides: true,
        navigation: {
            nextEl: "#contactSwiperNext",
            prevEl: "#contactSwiperPrev",
        },
    });


    /* Product page codes [Start] */
    const productMenu = document.querySelector('.productMenu');
    if( productMenu )
    {
        const menuOffset = productMenu.offsetTop - 49;
        window.addEventListener('scroll', () => {
            if (window.scrollY >= menuOffset) {
                productMenu.classList.add('productMenuSticky');
            } else {
                productMenu.classList.remove('productMenuSticky');
            }
        });
    }


    // HIGH LIGHT ACTIVE MENU LINK ON SCROLL
    function productPageHighlightLinkWhenScrolled() {
        let descriptionsBox = document.querySelector('#descriptionsBox');
        let attributesBox = document.querySelector('#attributesBox');
        let commentsBox = document.querySelector('#commentsBox');

        if( descriptionsBox && attributesBox && commentsBox )
        {
            window.addEventListener('scroll', () => {
                let scrollPosition = window.scrollY + window.innerHeight / 3;

                if (scrollPosition >= descriptionsBox.offsetTop && scrollPosition < attributesBox.offsetTop) {
                    document.querySelector('a[href$="#descriptionsBox"]').classList.add('active');
                    document.querySelector('a[href$="#attributesBox"]').classList.remove('active');
                    document.querySelector('a[href$="#commentsBox"]').classList.remove('active');
                }
                else if (scrollPosition >= attributesBox.offsetTop && scrollPosition < commentsBox.offsetTop) {
                    document.querySelector('a[href$="#descriptionsBox"]').classList.remove('active');
                    document.querySelector('a[href$="#attributesBox"]').classList.add('active');
                    document.querySelector('a[href$="#commentsBox"]').classList.remove('active');
                }
                else if (scrollPosition >= commentsBox.offsetTop) {
                    document.querySelector('a[href$="#descriptionsBox"]').classList.remove('active');
                    document.querySelector('a[href$="#attributesBox"]').classList.remove('active');
                    document.querySelector('a[href$="#commentsBox"]').classList.add('active');
                }
                else {
                    document.querySelector('a[href$="#descriptionsBox"]').classList.remove('active');
                    document.querySelector('a[href$="#attributesBox"]').classList.remove('active');
                    document.querySelector('a[href$="#commentsBox"]').classList.remove('active');
                }
            });
        }
    }

    productPageHighlightLinkWhenScrolled();

    const productSwiper2 = new Swiper('#productSwiper2', {
        modules: [Thumbs, Mousewheel],
        direction: window.innerWidth >= 1024 ? 'vertical' : 'horizontal',
        slidesPerView: 4,
        spaceBetween: 16,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        mousewheel: true,

        breakpoints: {
            480:  { slidesPerView: 4.5 },
            768:  { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
            1280: { slidesPerView: 4.5, spaceBetween: 5 },
        },

        on: {
            resize(swiper) {
                const newDir = window.innerWidth >= 1024 ? 'vertical' : 'horizontal';
                if (swiper.params.direction !== newDir) {
                    swiper.changeDirection(newDir);
                }
            },
        },
    });

    let productSwiper1 = new Swiper("#productSwiper1", {
        modules: [Navigation, Thumbs],
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        navigation: {
            nextEl: "#contactSwiperNext",
            prevEl: "#contactSwiperPrev",
        },
        thumbs: {
            swiper: productSwiper2,
        },
    });

    // SHOW MORE DESCRIPTION


    /* Product page codes [End] */




    /* Wooden page codes [Start] */

    let whpHouseSectionSwiper = new Swiper("#whpHouseSectionSwiper", {
        modules: [Navigation],
        slidesPerView: 4,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 4.3,
            },
            768: {
                slidesPerView: 5.7,
            },
            1024: {
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 6,
            },
            1280: {
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 8,
            },
        },
        navigation: {
            nextEl: "#whpHouseSectionSwiperNext",
            prevEl: "#whpHouseSectionSwiperPrev",
        },
    });


    let whpCategoriesSwiper = new Swiper("#whpCategoriesSwiper", {
        slidesPerView: 2.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5,
                enabled: false,
            },
        },
    });


    let whpCategoriesSwiper2 = new Swiper("#whpCategoriesSwiper2", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4.5,
            },
        },
    });


    /* TIMELINE PROGRESS */

    const timelineItems = document.querySelectorAll('.timeline-item');
    const movingCircle = document.querySelector('.moving-circle');
    const progressBefore = document.querySelector('.progress-before');
    const progressAfter = document.querySelector('.progress-after');
    const progressBar = document.querySelector('.progress-bar');

    const onScroll = () => {
        let closestItem = null;
        let minDistance = Infinity;

        timelineItems.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const distance = Math.abs(rect.top - window.innerHeight / 2);

            if (distance < minDistance) {
                minDistance = distance;
                closestItem = item;
            }
        });

        if (closestItem) {
            const rect = closestItem.getBoundingClientRect();
            const circleTop = closestItem.offsetTop + closestItem.offsetHeight / 2;
            movingCircle.style.top = `${circleTop}px`;

            timelineItems.forEach((item) => item.classList.remove('active'));
            closestItem.classList.add('active');
        }
    };

    document.addEventListener('scroll', onScroll);
    onScroll();

    /* TIMELINE PROGRESS */

     // Wooden page codes [End]


    let thwKeyFeaturesSwiper = new Swiper("#thwKeyFeaturesSwiper", {
        modules: [Pagination,Grid],
        slidesPerView: 1.3,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView:2.5,
            },
            1024: {
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 2,
            },
            1280: {
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 3,
                spaceBetween: 20,
                enabled: false,
            },
        },
        pagination: {
            el: "#thwKeyFeaturesSwiperPagination",
        },
    });




    let thwLatestProductsSwiper = new Swiper("#thwLatestProductsSwiper", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5,
            },
        },
    });


    let thwUsagesSwiper = new Swiper("#thwUsagesSwiper", {
        modules: [Grid],
        grid: {
            rows: 2,
            fill: 'row'
        },
        slidesPerView: 1.1,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView:2.5,
            },
            1024: {
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 2,
            },
            1280: {
                grid: {
                    rows: 4,
                    fill: 'row'
                },
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 2,
                spaceBetween: 40,
                enabled: false,
            },
        },
    });


    let thwSpecialCategoriesSwiper = new Swiper("#thwSpecialCategoriesSwiper", {
        modules: [Grid],
        slidesPerView: 1.3,
        grid: {
            rows: 3,
            fill: 'row'
        },
        loop: false,
        spaceBetween: 14,
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 2.5,
            },
        },
    });


    let thwCategoriesSwiper2 = new Swiper("#thwCategoriesSwiper2", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4.5,
            },
        },
    });

    let pwConsSwiper = new Swiper("#pwConsSwiper", {
        modules: [Pagination,Navigation],
        slidesPerView: 1.3,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView:2.5,
            },
            1024: {
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 2,
            },
            1280: {
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 4,
            },
        },
        pagination: {
            el: "#pwConsSwiperPagination",
        },
        navigation: {
            nextEl: "#pwConsSwiperNext",
            prevEl: "#pwConsSwiperPrev",
        },
    });


    let pwLatestProductsSwiper = new Swiper("#pwLatestProductsSwiper", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5,
            },
        },
    });

    let pwCategoriesSwiper = new Swiper("#pwCategoriesSwiper", {
        modules: [FreeMode],
        slidesPerView: 2.5,
        freeMode: true,
        spaceBetween: 10,
        breakpoints: {
            768: {
                slidesPerView: 3,
                enabled: false,
            },
            1024: {
                slidesPerView: 3,
                enabled: false,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 3,
                enabled: false,
            },
        },
    });

    let pwFeaturesSwiper = new Swiper("#pwFeaturesSwiper", {
        modules: [Pagination,Grid],
        slidesPerView: 1.3,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView:2.5,
            },
            1024: {
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 2,
            },
            1280: {
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 3,
                spaceBetween: 20,
                enabled: false,
            },
        },
        pagination: {
            el: "#pwFeaturesSwiperPagination",
        },
    });



    let pwUsagesSwiper = new Swiper("#pwUsagesSwiper", {
        modules: [Grid],
        grid: {
            rows: 2,
            fill: 'row'
        },
        slidesPerView: 1.1,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView:1.8,
            },
            1024: {
                grid: {
                    rows: 2,
                    fill: 'row'
                },
                loop: false,
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 2,
            },
            1280: {
                grid: {
                    rows: 3,
                    fill: 'row'
                },
                loop: false,
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 2,
                spaceBetween: 40,
                enabled: false,
            },
        },
    });


    let pwSpecialCategoriesSwiper = new Swiper("#pwSpecialCategoriesSwiper", {
        modules: [Grid],
        slidesPerView: 1.3,
        grid: {
            rows: 3,
            fill: 'row'
        },
        loop: false,
        spaceBetween: 14,
        breakpoints: {
            480: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 2.5,
            },
        },
    });


    let pwCategoriesSwiper2 = new Swiper("#pwCategoriesSwiper2", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4.5,
            },
        },
    });
}


["livewire:initialized", "livewire:navigated", "livewire:updated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})



// let deferredPrompt;
//
// window.addEventListener('beforeinstallprompt', (event) => {
//     // Prevent the default behavior, which is to show the browser's install prompt
//     event.preventDefault();
//
//     // Store the event object for later use
//     deferredPrompt = event;
//
//     // You can now show a custom install button or perform other actions
//     // to encourage the user to install the PWA
//     showInstallButton();
// });
//
// function showInstallButton() {
//     // Show your custom install button and attach an event handler
//     console.log('show install btn');
//     const installButton = document.getElementById('install-button');
//
//     if (installButton) {
//         installButton.style.display = 'block';
//
//         installButton.addEventListener('click', () => {
//             // Trigger the deferredPrompt to show the browser's install prompt
//             deferredPrompt.prompt();
//
//             // Wait for the user to respond to the install prompt
//             deferredPrompt.userChoice.then((choiceResult) => {
//                 if (choiceResult.outcome === 'accepted') {
//                     console.log('User accepted the install prompt');
//                 } else {
//                     console.log('User dismissed the install prompt');
//                 }
//
//                 // Reset the deferredPrompt variable
//                 deferredPrompt = null;
//             });
//         });
//     }
// }
